import { pageTitle } from 'ember-page-title';
import { t } from 'ember-intl';
import { and, eq } from 'ember-truth-helpers';

import PageOrganizationsDetailRestrictedAccess from 'hcp/components/page/organizations/detail/restricted-access';
import PageOrganizationsDetailOverview from 'hcp/components/page/organizations/detail/overview';

<template>
  {{pageTitle (t "page-title.organizations.detail-overview")}}

  {{#if
    (and
      @controller.model.hasNoOrgRole (eq @controller.model.projects.length 0)
    )
  }}
    <PageOrganizationsDetailRestrictedAccess
      @organization={{@controller.model.organization}}
    />
  {{else}}
    <PageOrganizationsDetailOverview
      @runningStatement={{@controller.model.runningStatement}}
      @organization={{@controller.model.organization}}
      @projects={{@controller.model.projects}}
      @userPrincipals={{@controller.model.userPrincipals}}
      @hasNoOrgRole={{@controller.model.hasNoOrgRole}}
    />
  {{/if}}
</template>
